<template>
  <v-card class="mx-auto" max-width="500">
    <v-toolbar
      color="secondary"

    >
      <v-toolbar-title>ICE DETAILS PREVIEW</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$router.go(-1)">Back</v-btn>

    </v-toolbar>
    <v-img
      :src="require('@/assets/media/mi-sos-scan.png')"
    ></v-img>
    <v-list two-line>
      <v-list-item-group
        multiple
        active-class="pink--text"
      >
        <!-- <v-list-item-content :class="itemPad">
          <v-list-item-subtitle color="primary" class="text-h6">My Name is:</v-list-item-subtitle>
          <v-list-item-title class="text-h6 text-sm-h5 text-md-h4">{{ details.fullname }} </v-list-item-title>
        </v-list-item-content> -->
        <v-card class="ma-1" flat :class="itemPad">
          <v-row class="">
            <v-col cols="12" class="ttext-overline mb-0 pa-0 secondary--text">My Name is:</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0">{{ details.fullname }}</v-col>
          </v-row>
        </v-card>
        <v-divider></v-divider>
        <v-card class="ma-1" flat :class="itemPad">
          <v-row class="">
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Also known as:</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0">{{ details.known_as }}</v-col>
          </v-row>
        </v-card>
        <v-divider></v-divider>
        <v-card class="ma-1" flat :class="itemPad">
          <v-row class="">
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Gender:</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0 " v-text="getGender(details.gender)">{{ details.known_as }}</v-col>
          </v-row>
        </v-card>
        <v-divider></v-divider>
        
        <v-card class="ma-1" flat :class="itemPad" v-if="details.nhs_number">
          <v-row class="">
            <v-col cols="12" class="ttext-overline mb-0 pa-0 secondary--text">NHS Number:</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0">{{ details.nhs_number }}</v-col>
          </v-row>
        </v-card>

        <v-divider></v-divider>
        <v-card class="ma-1" :class="itemPad" v-if="details.blood_group" flat>
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Blood Group:</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0 ">{{ details.blood_group }}</v-col>
          </v-row>
        </v-card>
        <v-divider></v-divider>

        <v-card :class="itemPad" v-if="details.organ_donor">
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Am I an organ donor?:</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0">{{ details.covid }}<span v-if="details.organ_donor">YES</span><span v-else>No</span></v-col>
          </v-row>
        </v-card>

        <v-divider></v-divider>

        <v-card :class="itemPad" v-if="details.covid_status" flat>
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Covid Status</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0">{{ details.covid_status }}</v-col>
          </v-row>
        </v-card>

        <v-divider></v-divider>
        <v-card :class="itemPad" class="ma-1" flat>
          <v-row v-for="(ices, i) in ice" :key="i">

            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">ICE Contact</v-col>
            <v-col cols="12" class="text-h6 text-sm-h5 mt-0 pa-0 ">Name: {{ ices.firstname }} {{ ices.surname }}</v-col>
            <v-col cols="12" class="text-subtitle-1 text-sm-body-1 mt-0 pa-0" ><strong>Relationship</strong>: {{ iceRel(ices) }} </v-col>
            <v-col cols="12" class="text-subtitle-1 text-sm-body-1 mt-0 pa-0" v-if="ices.phone_mobile"><strong>Mobile</strong>: {{ ices.phone_mobile }}</v-col>
            <v-col cols="12" class="text-subtitle-1 text-sm-body-1 mt-0 pa-0" v-if="ices.phone_home"><strong>Home</strong> {{ ices.phone_home }}</v-col>
          </v-row>
          
        </v-card>

        <v-divider></v-divider>

        <v-card :class="itemPad" class="ma-2" flat v-if="conditions.length">
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Medical Conditions</v-col>
            <v-col cols="12" class="text-body-1 text-sm-h5 mt-0 pa-0" v-for="(condition, indes) in conditions" :key="indes">
              <div>
                {{condition.condition.condition}} diagnosed in {{ condition.month_diagnosed }} {{ condition.year_diagnosed }}
              </div>
            </v-col>
          </v-row>
          
        </v-card>

          <v-divider></v-divider>


        <v-card :class="itemPad" class="ma-2" flat v-if="medications.length">
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text ">Medications</v-col>
            <v-col cols="12" class="text-body-1 text-sm-h5 mt-0 pa-0 " v-for="(meds, indes) in medications" :key="indes">
              {{ meds.sos_medication.medication }} ({{ meds.sos_medication.presentation }})
            </v-col>
          </v-row>
        </v-card>

        <v-divider></v-divider>

        <v-card :class="itemPad" class="ma-2" flat v-if="allergies.length">
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Allergies</v-col>
            <v-col cols="12" class="text-body-1 text-sm-h5 mt-0 pa-0" v-for="(allergy, indes) in allergies" :key="indes">
              {{ displayAllergy(allergy) }} ({{ allergy.allergies.allergytype }})
            </v-col>
          </v-row>
        </v-card>

        <v-divider></v-divider>


        <v-card class="ma-1" :class="itemPad" flat v-if="devices.length">
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Devices</v-col>
            <v-col cols="12" class="text-body-1 text-sm-h5 mt-0 pa-0 " v-for="(device, indes) in devices" :key="indes" >
              {{ device.devices.device }} installed in {{ device.month_installed }} {{ device.year_installed }}
            </v-col>
          </v-row>
          
        </v-card>

        <v-divider></v-divider>

        <v-card class="ma-1" :class="itemPad" flat v-if="vaccines.length">
          <v-row>
            <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text">Vaccinations</v-col>
              <v-col cols="12" class="text-body-1 text-sm-h5 mt-0 pa-0" v-for="(vaccine, indes) in vaccines" :key="indes" >
                {{ vaccine.vaccination.vaccine }} administered on {{ vaccine.month_taken }} {{ vaccine.year_taken }}
              </v-col>
          </v-row>
          
        </v-card>

        <v-divider></v-divider>

        <v-row v-if="files.length" class="mt-6">
          <v-col cols="12" class="text-overline mb-0 pa-0 secondary--text" :class="itemPad">Images</v-col>
          <v-col cols="12" v-for="(file, indes) in files" :key="indes">
            <v-card> 
              <v-img aspect-ratio="1.7"
                  contain 
                  :src="imageSrc(file.filename)" 
                  @click="enlarge(file.filename)" 
                  class="ui small image" alt="">
                
              </v-img>
              <v-card-title class="text-h5 pa-5 my-5 text-center" v-text="file.title"></v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-list-item-group>
    </v-list>
    <Fullscreen ref="full" />
    <ViewPDF ref="thepdf" />
  </v-card>
</template>

<script>
import Fullscreen from "@/components/views/ImageFullScreen";
import ViewPDF from "@/components/views/FileViewPDF"
import { mapGetters } from "vuex";
export default {
  name: "sosPublic",
  data() {
    return {
      logo: "@/assets/media/mi-sos-scan.png",
      loading: true,
      code: this.$route.params.code,
      error: false,
      itemPad: "pl-10"
    };
  },
  created() {
    
    this.$store
      .dispatch("publics/aAll", this.code)
      .then(response => {
        if (response) {
          this.loading = false;
        } else if (response == false) {
          //this.loading=false
          this.error = true;
        }
      });
  },
  components: {
    Fullscreen,
    ViewPDF
  },
  computed: {
    ...mapGetters("publics", {
      username: "gPublicUsername",
      details: "gPublicDetails",
      conditions: "gPublicConditions",
      allergies: "gPublicAllergies",
      vaccines: "gPublicVaccines",
      devices: "gPublicDevices",
      medications: "gPublicMedications",
      files: "gPublicFiles",
      ice: "gPublicIce",
    })
  },
  methods: {
    displayAllergy(allergy) {
      if (allergy.medication ==  null) {
        return allergy.allergies.allergy
      } else {
        return allergy.medication.medication
      }
      
    },
    imageSrc(chartName) {
      if(chartName.includes("files/file-")) {
        return "https://api.mi-sos.org/uploads/images/sample_pdf.png"
      } 
      if (chartName.includes("https://api.mi-sos.org/uploads")) {
        return chartName
      }
      return "https://api.mi-sos.org/uploads/" + chartName;
    },
    enlarge(img) {
      if (img.includes(".pdf")) {
        this.$refs.thepdf.openDialog(img)
      } else {
        this.$refs.full.enlarge(img);
      }
    },
    getGender(g) {
      if (g == "m") {
        return "Male"
      } else if (g =="f") {
        return "Female"
      } 
      return ""
    },
    iceRel(val) {
      return val.relationship;//['relationship'];
    }
  }
};
</script>

<style>
  .full-image {
    position:fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left:0;
    background-color: rgba(230, 229, 191, 0.87);
  }

  .wrapped {
    word-wrap: break-word;
    word-break: break-all;
  }
</style>